
import { useState } from 'react';

export const useEditingState = () => {
  const [editingProductId, setEditingProductId] = useState<string | null>(null);
  const [addingProduct, setAddingProduct] = useState(false);

  const handleEditProduct = (id: string) => {
    console.log("Setting product to edit:", id);
    setEditingProductId(id);
  };

  const handleAddProductForm = () => {
    console.log("Setting product creation mode");
    setAddingProduct(true);
    // When adding a product, we need to set the editingProductId to 'new'
    setEditingProductId('new');
  };

  const handleCloseForm = () => {
    console.log("Closing product form");
    setEditingProductId(null);
    setAddingProduct(false);
  };

  return {
    editingProductId,
    addingProduct,
    setAddingProduct,
    handleEditProduct,
    handleAddProductForm,
    handleCloseForm,
    setEditingProductId
  };
};
